var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125.43 78.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.43,
    height: 78.39,
    rx: 4.18,
    ry: 4.18,
    fill: "#3957a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.72 50.97h-6.13l3.83-23.53h6.13l-3.83 23.53zM46.44 27.44 40.6 43.62l-.69-3.48-2.06-10.58a2.63 2.63 0 0 0-2.91-2.12h-9.66l-.11.4a22.81 22.81 0 0 1 6.41 2.69L36.9 51h6.39L53 27.44zM94.63 51h5.63l-4.9-23.53h-4.93a2.81 2.81 0 0 0-2.83 1.75L78.46 51h6.39l1.27-3.49h7.8zm-6.74-8.32 3.22-8.81 1.81 8.81zm-8.95-9.58.87-5.1a17.71 17.71 0 0 0-5.51-1C71.26 27 64 28.35 64 34.81c0 6.08 8.48 6.15 8.48 9.35s-7.6 2.62-10.11.6l-.91 5.29a17.11 17.11 0 0 0 6.91 1.33c4.18 0 10.49-2.17 10.49-8.06 0-6.12-8.55-6.69-8.55-9.35s6.01-2.32 8.63-.87z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.91 40.14-2.06-10.58a2.63 2.63 0 0 0-2.91-2.12h-9.66l-.11.4a23.73 23.73 0 0 1 9.09 4.56 18.39 18.39 0 0 1 5.65 7.74z",
    fill: "#f9a533"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7a5a09ce3366eefa20c73be7d2ad7e0c.svg";
export { ForwardRef as ReactComponent };